export default class LabelParseException extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'LabelParseException';
    }
}